import { PropsWithChildren } from "react";

export function ScreenHeader({ children }: PropsWithChildren) {
    return (
        <h1 className="text-xl font-semibold text-secondary-gray-dark mb-40 space-y-16">
            {children}
        </h1>
    );
}
